type Props = {
  title: string;
  hint: string;
  checked: boolean;
  onChange: (value: boolean) => void;
};

export default function LabelCheck({
  checked,
  onChange,
  title,
  hint,
  disabled = false,
}) {
  return (
    <div
      className={`flex items-start p-3 border rounded-lg ${disabled ? "bg-slate-50 border-slate-200 opacity-70" : "bg-white border-slate-200 hover:bg-slate-50"}`}
    >
      <button
        type="button"
        className={`flex-shrink-0 w-5 h-5 flex items-center justify-center border rounded mr-3 mt-0.5 transition-colors ${
          checked
            ? "bg-primary-blue "
            : "bg-white border-slate-300"
        } ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
      >
        {checked && (
          <svg
            className="w-3 h-3 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </button>
      <div>
        <label
          className={`text-sm font-medium ${disabled ? "text-slate-600" : "text-slate-900"}`}
        >
          {title}
        </label>
        {hint && (
          <p
            className={`text-xs mt-1 ${disabled ? "text-slate-500" : "text-slate-600"}`}
          >
            {hint}
          </p>
        )}
      </div>
    </div>
  );
}
